import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { redConfermaApi } from '../../services/api'

interface ConfermaInfo {
  titolo: string
  immobile_nome: string
  data_scadenza: string
  stato: 'attiva' | 'in_pausa' | 'confermata'
  confermata_da: string | null
}

type UIState = 'loading' | 'errore' | 'pronto' | 'invio' | 'confermata'

export default function RedConfermaScadenza() {
  const { token } = useParams<{ token: string }>()
  const [uiState, setUiState] = useState<UIState>('loading')
  const [dati, setDati] = useState<ConfermaInfo | null>(null)

  useEffect(() => {
    if (!token) { setUiState('errore'); return }
    redConfermaApi.verifica(token)
      .then(r => {
        setDati(r.data)
        setUiState(r.data.stato === 'confermata' ? 'confermata' : 'pronto')
      })
      .catch(() => setUiState('errore'))
  }, [token])

  const handleConferma = async () => {
    if (!token) return
    setUiState('invio')
    try {
      const res = await redConfermaApi.conferma(token)
      setDati(res.data)
      setUiState('confermata')
    } catch {
      setUiState('errore')
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="card p-6 w-full max-w-md text-center">
        {uiState === 'loading' && <p className="text-gray-500">Caricamento...</p>}

        {uiState === 'errore' && (
          <>
            <h1 className="text-lg font-semibold text-red-600 mb-2">Link non valido</h1>
            <p className="text-sm text-gray-500">Il link utilizzato non è corretto o la scadenza non esiste più.</p>
          </>
        )}

        {(uiState === 'pronto' || uiState === 'invio') && dati && (
          <>
            <h1 className="text-lg font-semibold text-gray-800 mb-1">{dati.titolo}</h1>
            <p className="text-sm text-gray-500 mb-1">{dati.immobile_nome}</p>
            <p className="text-sm text-gray-500 mb-4">Scadenza: {new Date(dati.data_scadenza).toLocaleDateString('it-IT')}</p>
            <button onClick={handleConferma} disabled={uiState === 'invio'} className="btn-primary w-full">
              {uiState === 'invio' ? 'Invio...' : 'Ho ricevuto, ferma gli avvisi'}
            </button>
          </>
        )}

        {uiState === 'confermata' && dati && (
          <>
            <h1 className="text-lg font-semibold text-green-600 mb-2">Confermato</h1>
            <p className="text-sm text-gray-600 mb-1">{dati.titolo}</p>
            <p className="text-sm text-gray-500">Non riceverai altri avvisi per questa scadenza.</p>
          </>
        )}
      </div>
    </div>
  )
}
